export const AVATAR_VOLUME_CHANGED_EVENT = "avatar_volume_changed";

function getAvatarVolumeEventTarget() {
  if (typeof AFRAME === "undefined") return null;
  if (!AFRAME.scenes || !AFRAME.scenes[0]) return null;

  return AFRAME.scenes[0];
}

export function emitAvatarVolumeChanged({ sessionId, gainMultiplier }) {
  const target = getAvatarVolumeEventTarget();
  if (!target || !sessionId) return;

  target.emit(
    AVATAR_VOLUME_CHANGED_EVENT,
    {
      sessionId,
      gainMultiplier
    },
    false
  );
}

export function addAvatarVolumeChangedListener(listener) {
  const target = getAvatarVolumeEventTarget();
  if (!target || !listener) {
    return () => {};
  }

  target.addEventListener(AVATAR_VOLUME_CHANGED_EVENT, listener);
  return () => {
    target.removeEventListener(AVATAR_VOLUME_CHANGED_EVENT, listener);
  };
}
